@if (!hidden) {
    <ds-card
        msThemedCard
        [themeCardElevated]="themeCardElevated"
        [themeBorderRadius]="themeBorderRadius"
        [radius]="!isMobile()"
        [border]="isEpcotEnabled()"
        [elevated]="true">
        <ds-accordion
            msThemedAccordion
            variant="transparent"
            [themedAccordionVariant]="themedAccordionVariant"
            [withCard]="true"
            [open]="expanded"
            (openedChange)="toggle()">
            <ds-accordion-header class="accordion-header-alignment">
                <div slot="start">
                    <div slot="title">{{ title }}</div>
                </div>
                <span *dsAccordionTrigger="let isOpen">
                    @if (!isEpcotEnabled()) {
                        @if (dismissable && isOpen) {
                            <vn-icon name="theme-ex" size="12" (click)="dismiss($event)" />
                        } @else {
                            <vn-icon name="theme-down" size="12" />
                        }
                    } @else {
                        <vn-icon size="16" [name]="isOpen ? 'theme-up' : 'theme-down'" />
                    }
                </span>
            </ds-accordion-header>
            <ng-template #content>
                @if (expanded) {
                    <ms-scroll-adapter size="medium" [scrollItems]="stories">
                        <div class="story-list">
                            @for (story of stories; track story.id) {
                                <ms-story-preview
                                    [story]="story"
                                    [priority]="story.id === storyWithImage"
                                    [more]="viewTitle"
                                    [stretch]="strech"
                                    (open)="openStory(story)" />
                            }
                        </div>
                    </ms-scroll-adapter>
                }
            </ng-template>
        </ds-accordion>
    </ds-card>
}
